import { render } from "./PartnerOntap.vue?vue&type=template&id=a2664c9c"
import script from "./PartnerOntap.vue?vue&type=script&lang=js"
export * from "./PartnerOntap.vue?vue&type=script&lang=js"

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__